import { axios, AxiosResponse } from '@/plugins/axios';

import {
	RuleOptions,
	RuleData,
	QuestionsOptions,
	QuestionData
} from './types';

export function getQuestions(params: QuestionsOptions): Promise<AxiosResponse<QuestionData[]>> {
	return axios.get('/api/eligibilities/questions', {
		params
	});
}

export function getRules(params: RuleOptions): Promise<AxiosResponse<RuleData>> {
	return axios.post('/api/eligibilities/rule', params);
}
